import React, { Component } from 'react'
import PropTypes from 'prop-types'
//import firebase from 'firebase';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table'

//receives transaction prop from transactionSwitcher

//this component deals with market transactions
class MarketTransaction extends Component {
  constructor (props) {
    //console.log("MarketTransactions constructor");
    super(props)
    this.state = {
      transactions: []
    }
  }

// componentWillMount() {
//
// }

  componentDidMount () {
    //console.log("MarketTransactions componentDidMount");
    //allows transactions to persist

    //console.log("mounted",this.props,this.state);
    this.setState({
      transactions: this.props.transaction
    })
  }

  /**
   * On nextProps, set the state to be rendered
   * @param nextProps
   */
  componentWillReceiveProps (nextProps) {
    let trns = []
    trns.push(nextProps)
    // trns[0]['transaction'].sort(function(a,b){
    //   var nameA = a.Time.toUpperCase(); // ignore upper and lowercase
    //   var nameB = b.Time.toUpperCase(); // ignore upper and lowercase
    //   if (nameA < nameB) {
    //     return 1;
    //   }
    //   if (nameA > nameB) {
    //     return -1;
    //   }
    //   return 0;
    // });
    this.setState({
      transactions: trns[0]['transaction']
    })
  }

  /**
   * mapping market transactions while rendering color based on sell or buy
   * @returns {*}
   */
  render () {
    let typeClass = function(trnType){
      switch(trnType){
        case 'Sell':
          return 'sell-transaction transaction-log-row';
        case 'Buy':
          return 'buy-transaction transaction-log-row';
        case 'Bid':
          return 'bid-transaction transaction-log-row';
        case 'Ask':
          return 'ask-transaction transaction-log-row';
      }
    };
    let typeVerb = function(trnType){
      switch(trnType){
        case 'Sell':
          return 'Sold';
        case 'Buy':
          return 'Bought';
        case 'Bid':
          return 'Bid for';
        case 'Ask':
          return 'Offered';
      }
    }
    return (
      <div style={{"overflow-x": "auto"}}>
        <div style={{ height: "25em", overflowY: "auto" }}>
          <table className="market-transactions-table">
            <thead>
              <tr>
                <th className="market-transactions-header">Timestamp</th>
                <th className="market-transactions-header">Volume</th>
                <th className="market-transactions-header">Symbol</th>
                <th className="market-transactions-header">Type</th>
                <th className="market-transactions-header">Price</th>
              </tr>
            </thead>

            <tbody>
              {this.state.transactions.map((trn, index) => {
                let rowColor = '';
                switch(trn.Type) {
                  case 'Sell': rowColor = '#EF4444'; break;
                  case 'Buy': rowColor = '#31BA7F'; break;
                  case 'Bid': rowColor = '#2B4365'; break;
                  case 'Ask': rowColor = '#744210'; break;
                  default: rowColor = '#FFFFFF';
                }
                return (
                  <tr className={"market-transactions-row"} key={index}>
                    <td className="market-transactions-data">{trn.Time.substr(11,5)}</td>
                    <td className="market-transactions-data">{trn.Volume} shares of</td>
                    <td className="market-transactions-data">carbon credits were</td>
                    <td style={{"color": rowColor, }} className="market-transactions-data">{typeVerb(trn.Type)} at</td>
                    <td style={{"color": rowColor, }} className="market-transactions-data">${(trn.Price / 100).toFixed(2)}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

MarketTransaction.propTypes = {
  nextProps: PropTypes.array
}

export default MarketTransaction



// WEBPACK FOOTER //
// ./src/components/Orderbook/MarketTransactions.js